import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'

export default function AccountButton() {
  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const { user, logout } = useAuth()

  React.useEffect(() => { setOpen(false) }, [location.pathname])

  React.useEffect(() => {
    const onDoc = (e) => { if (!e.target.closest('.account-dd')) setOpen(false) }
    document.addEventListener('click', onDoc)
    return () => document.removeEventListener('click', onDoc)
  }, [])

  const avatar = user?.profileImageUrl
    ? `${user.profileImageUrl}${user.profileImageUrl.includes('?') ? '&' : '?'}t=${Date.now()}`
    : null

  return (
    <div className="relative account-dd">
      <button onClick={()=>setOpen(v=>!v)} className="w-10 h-10 rounded-full border border-blue-100 bg-white flex items-center justify-center overflow-hidden">
        {avatar
          ? <img src={avatar} alt="avatar" className="w-full h-full object-cover"/>
          : <svg width="20" height="20" viewBox="0 0 24 24"><path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-5 0-9 2.5-9 5v1h18v-1c0-2.5-4-5-9-5Z" fill="currentColor"/></svg>
        }
      </button>

      {/* Menu déroulant */}
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white border border-blue-100 rounded-xl shadow-card p-2 flex flex-col z-[2100]" role="menu">
          {user ? (
            <>
              <div className="px-3 py-2 text-gray-700">
                <div className="font-semibold">{user.firstName} {user.lastName}</div>
                <div className="text-sm text-gray-500">{user.email}</div>
              </div>
              <hr className="my-1" />
              <button
                className="text-left font-semibold px-3 py-2 rounded-md hover:bg-blue-50 hover:text-primary"
                onClick={() => navigate('/profile')}
                role="menuitem"
              >
                {t('auth.profile', 'Mon profil')}
              </button>
              <button
                className="text-left font-semibold px-3 py-2 rounded-md hover:bg-red-50 hover:text-red-600"
                onClick={logout}
                role="menuitem"
              >
                {t('auth.logout', 'Se déconnecter')}
              </button>
            </>
          ) : (
            <>
              <button
                className="text-left font-semibold px-3 py-2 rounded-md hover:bg-blue-50 hover:text-primary"
                onClick={() => navigate('/login')}
                role="menuitem"
              >
                {t('auth.login', 'Connexion')}
              </button>
              <button
                className="text-left font-semibold px-3 py-2 rounded-md hover:bg-blue-50 hover:text-primary"
                onClick={() => navigate('/signup')}
                role="menuitem"
              >
                {t('auth.signup', 'Inscription')}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}
